<template>
  <div class="download-container">
    <!-- <div class="notification" @click="downloadPdf(notification1.pdf)">
      <img :src="notification1.image" alt="First Notification" class="notification-image" />
      <h2>{{ notification1.title }}</h2>
    </div>
    <div class="notification" @click="downloadPdf(notification3.pdf)">
      <img :src="notification3.image" alt="First Notification" class="notification-image" />
      <h2>{{ notification3.title }}</h2>
    </div> -->
<!--    &lt;!&ndash; 第一届国际热带植物学术会议第二轮通知 &ndash;&gt;-->
<!--    <div class="notification" @click="downloadImage(notification1.image)">-->
<!--      <img :src="notification1.image" alt="First Notification" class="notification-image" />-->
<!--      <h2>{{ notification1.title }}</h2>-->
<!--    </div>-->

<!--    &lt;!&ndash; 关于第一届国际热带植物学术会议延期的通知 &ndash;&gt;-->
<!--    <div class="notification" @click="downloadImage(notification2.image)">-->
<!--      <img :src="notification2.image" alt="Second Notification" class="notification-image" />-->
<!--      <h2>{{ notification2.title }}</h2>-->
<!--    </div>-->

<!--    &lt;!&ndash; Announcement of The 1st International Conference on Tropical Plants &ndash;&gt;-->
<!--    <div class="notification" @click="downloadImage(notification3.image)">-->
<!--      <img :src="notification3.image" alt="Third Notification" class="notification-image" />-->
<!--      <h2>{{ notification3.title }}</h2>-->
<!--    </div>-->
  </div>
</template>

<script>
import {ref} from "vue";

export default {
  name: 'Download',
  data() {
    return {
      notification1: {
        title: '第三届热带植物国际会议（3rd ICTP）第一轮会议通知',
        image: require('@/assets/images/Announcement1-1.png'), // 替换为实际图片路径
        pdf: require('@/assets/images/Announcement1.png'),
      },
      notification3: {
        title: '第三届热带植物国际会议招商函',
        image: require('@/assets/images/Announcement-3.jpg'), // 替换为实际图片路径
        pdf: require('@/assets/images/Announcement-3.jpg'),
      },
    };
  },
  methods: {
    downloadPdf(downloadUrl) {
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = downloadUrl.substring(downloadUrl.lastIndexOf('/') + 1); // 获取文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style scoped>
.download-container {
  width: 66%; /* 整体宽度为66% */
  margin: 0 auto; /* 居中对齐 */
  display: flex; /* 横向排列 */
  gap: 20px; /* 通知之间的间距 */
  padding: 20px; /* 内边距 */
  flex-wrap: wrap; /* 换行以适应屏幕宽度 */
}

.notification {
  cursor: pointer; /* 鼠标悬停时显示手形光标 */
  border: 1px solid #ddd; /* 边框样式 */
  border-radius: 8px; /* 圆角 */
  overflow: hidden; /* 隐藏溢出部分 */
  padding: 10px; /* 内边距 */
  background-color: #f9f9f9; /* 背景颜色 */
  transition: box-shadow 0.3s; /* 过渡效果 */
  flex: 1 1 30%; /* 每个通知占据父容器的30% */
  max-width: 30%; /* 最大宽度 */
  max-height: 60vh;
}

.notification:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* 悬停效果 */
}

.notification-image {
  width: 100%; /* 照片宽度为父容器宽度的100% */
  height: 88%; /* 高度自适应 */
  border-radius: 8px; /* 圆角边框 */
}

h2 {
  margin: 10px 0 0; /* 标题的上下间距 */
  font-size: 1.2em; /* 标题字体大小 */
}
</style>
